import { cn } from "@/lib/utils";

const VARIANTS: Record<string, { bg: string; text: string; dot: string }> = {
  buy:     { bg: "bg-[rgba(0,220,130,0.2)]",  text: "text-[#00dc82]", dot: "bg-[#00dc82]" },
  sell:    { bg: "bg-[rgba(255,87,87,0.2)]",   text: "text-[#ff5757]", dot: "bg-[#ff5757]" },
  hold:    { bg: "bg-amber-500/20",            text: "text-amber-400", dot: "bg-amber-400" },
  watch:   { bg: "bg-zinc-700/30",             text: "text-zinc-400",  dot: "bg-zinc-400" },
  review:  { bg: "bg-zinc-700/30",             text: "text-zinc-400",  dot: "bg-zinc-400" },
  new:     { bg: "bg-amber-500/20",            text: "text-amber-400", dot: "bg-amber-400" },
  success: { bg: "bg-[rgba(0,220,130,0.15)]",  text: "text-[#00dc82]", dot: "bg-[#00dc82]" },
  danger:  { bg: "bg-[rgba(255,87,87,0.15)]",  text: "text-[#ff5757]", dot: "bg-[#ff5757]" },
  warning: { bg: "bg-amber-500/15",            text: "text-amber-400", dot: "bg-amber-400" },
  info:    { bg: "bg-blue-500/15",             text: "text-blue-400",  dot: "bg-blue-400" },
  default: { bg: "bg-zinc-700/30",             text: "text-zinc-400",  dot: "bg-zinc-500" },
};

interface BadgeProps {
  children: React.ReactNode;
  variant?: keyof typeof VARIANTS;
  className?: string;
  dot?: boolean;
}

export function Badge({ children, variant = "default", className, dot = true }: BadgeProps) {
  const v = VARIANTS[variant] ?? VARIANTS.default;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-mono font-bold",
        "uppercase tracking-wider",
        v.bg, v.text,
        className,
      )}
    >
      {dot && <span className={cn("w-1.5 h-1.5 rounded-full shrink-0", v.dot)} />}
      {children}
    </span>
  );
}

/** Auto-color badge based on signal type */
export function SignalBadge({ signal }: { signal: string }) {
  const variant = signal.toLowerCase() as keyof typeof VARIANTS;
  return <Badge variant={variant in VARIANTS ? variant : "default"}>{signal}</Badge>;
}
